var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgLoader-container"},[(!_vm.everythingDone)?_c('img',{staticClass:"placeholder",attrs:{"src":_vm.placeHolder,"alt":""}}):_vm._e(),_c('img',{staticClass:"origin",style:({ opacity: _vm.originOpacity,transition: `${_vm.duration}ms` }),attrs:{"src":_vm.src,"alt":""},on:{"load":_vm.handleLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }